import { FACING_ONLY_TRIGGERS, WORKFLOW_INTENT_ACTIONS, type WorkflowTrigger } from "@sagot/constants";
import type { useTranslation } from "@sagot/i18n";
import { defaultTriggerOptions, emptyDefinition } from "./definition-model";
import type { Definition, PathDef, TriggerOptions, WorkflowSettings } from "./types";

type TFunction = ReturnType<typeof useTranslation>["t"];

function define(paths: Record<string, PathDef>, settings: Partial<WorkflowSettings> = {}): Definition {
  const base = emptyDefinition();
  return { settings: { ...base.settings, ...settings }, paths };
}

/**
 * A blank workflow on a trigger only customer-facing workflows use cannot be saved empty (the server wants a step the
 * visitor sees, and an intent for "Visitor intent detected"): it starts with one greeting to edit. `chosen` are the
 * trigger options the person set while creating it (the watched attribute, the clicked element).
 */
export function starterFor(trigger: WorkflowTrigger, t: TFunction, chosen: TriggerOptions = {}): Definition | undefined {
  const defaults = defaultTriggerOptions(trigger);
  const trigger_options = defaults || Object.keys(chosen).length > 0 ? { ...defaults, ...chosen } : undefined;
  const options = trigger_options ? { trigger_options } : {};
  if (!FACING_ONLY_TRIGGERS.has(trigger)) return trigger_options ? define({ A: { steps: [] } }, options) : undefined;
  const base = emptyDefinition();
  const conditions = trigger === "intent_detected" ? { any: [{ all: [{ field: "intent.action", op: "is" as const, value: WORKFLOW_INTENT_ACTIONS[0] }] }] } : base.settings.conditions;
  return define({ A: { steps: [{ id: "welcome", type: "send_message", text: t("engage.workflows.create.starter") }] } }, { conditions, ...options });
}
